// Conversation adds one mode to the family: a per-turn breakdown whose positions are the
// answer's own a{n} keys rather than a resolved tag list. Every other mode is the family's.

import { calcChartsModelProps as calcOeChartsModelProps } from '@aytm/app/stats/page/question-views/oe/lib/props/charts-model'

export const calcChartsModelProps = inputs => {
  const { answer, viewMode, answerVariants } = inputs

  return calcOeChartsModelProps({
    ...inputs,
    calcExtraProps: () => ('chart' === viewMode ? { kind: 'conversation', viewMode, answer, answerVariants } : null)
  })
}
